import {
  CompleteBatchReportUploadInput,
  CompleteUploadRequest,
  CompleteUploadRequestList,
} from '@amzn/coral_com-amazon-transreportscenterservice';
import { FILE_PARTS_UPLOAD_SUCCESS } from '../actions/types';
import { UPLOAD_STATUS } from '../constants/upload';
import { completeBulkUploadFilesAction } from '../actions';

/**
 * custom middleware to check authorization on dispatch.
 * @returns {function({dispatch: *}): function(*): function(*): *}
 */
function completeBulkFileUploadMiddleware({
  getState,
}: {
  getState: Function;
}) {
  return (next: any) => (action: any) => {
    const result = next(action);

    const store = getState();

    const { type } = action;
    const bulkFilesPartsUpload =
      store?.reportsCenter?.bulkFilesPartsUpload ?? {};

    const bulkFilesKeys = Object.keys(bulkFilesPartsUpload);
    const bulkFilesUploadValues = Object.values(bulkFilesPartsUpload);
    const isBulkFilesPartUploadComplete =
      bulkFilesKeys.length &&
      bulkFilesUploadValues.every(
        (val) => val.status === UPLOAD_STATUS.SUCCESS
      );

    if (type === FILE_PARTS_UPLOAD_SUCCESS && isBulkFilesPartUploadComplete) {
      const completeBatchReportUploadInput =
        CompleteBatchReportUploadInput.clone({
          logisticsPartyId: bulkFilesUploadValues[0].logisticsPartyId,
          reportType: bulkFilesUploadValues[0].reportType,
          term: bulkFilesUploadValues[0].term,
          CompleteUploadRequestList: CompleteUploadRequestList.fromJson(
            bulkFilesUploadValues.map((bulkFilesUploadValue) =>
              CompleteUploadRequest.clone({
                key: bulkFilesUploadValue.key,
                uploadId: bulkFilesUploadValue.uploadId,
                supportingDocumentInfo:
                  bulkFilesUploadValue.supportingDocumentInfo,
                eTags: bulkFilesUploadValue.eTags,
                reportId: bulkFilesUploadValue.reportId,
              })
            )
          ),
        });
      return next(
        completeBulkUploadFilesAction.request({
          completeBatchReportUploadInput,
        })
      );
    }
    return result;
  };
}

export default completeBulkFileUploadMiddleware;
